import {fetchDataFromApi} from './apiHelper';

export const fetchAdmyStatisticFields = () => fetchDataFromApi('post', '/api/xml/admy-companies/fields');

export const fetchAdkStatisticFields = () => fetchDataFromApi('post', '/api/xml/adk-companies/fields');